var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { sortBy } from "lodash";
import { ElxActionButton, ElxContainer, ElxSearchBox, ElxTable, ElxLink, SearchBoxSize, ElxText, ElxFilter, FilterOptionPillMode, ElxPrimaryButton, } from "@elixir/components";
import { ElxNavLink } from "@elixir/fx";
import { Icon } from "@fluentui/react/lib/Icon";
import { Label, SelectionMode, Spinner, SpinnerSize, Stack, } from "@fluentui/react";
import { Text } from "@fluentui/react/lib/Text";
import { headerStyle, useEfdContainerStyles, lastUpdatedStyle } from "./MyEscalations.styles";
import { useLocaleStrings } from "../../library/providers/strings";
import { useRootContext } from "../../library/providers/root/RootContextProvider";
import { convertISOtoLocal } from "../../library/utilities/DateAndTimeFormatter";
import { visuallyHiddenStyle } from "../../commoncomponents/Common.styles";
import "./MyEscalationsStyle.css";
import DetailsPage from "../DetailsPage/DetailsPage";
import { UseMyEscalationsDispatch, UseMyEscalationsState, } from "../../reducers/MyEscalationsContext/MyEscalationsContextProvider";
import NoEscalationImage from "../../images/noEscalations.png";
import { renderStatusCell, reportInvalidStageProgression, } from "../../library/utilities/StatusCellRenderer";
import { logError } from "../../library/logging/loggingService";
import { mapMyEscalationToCaseData } from "../../library/utilities/MyEscalationMapper";
const topStack = { childrenGap: 5 };
const midStack = { childrenGap: 10 };
/** Formats a Date as a relative time string (e.g. "just now", "12s ago", "3m ago"). */
function formatRelativeTime(date) {
    const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
    if (seconds < 5)
        return "just now";
    if (seconds < 60)
        return `${seconds}s ago`;
    const minutes = Math.floor(seconds / 60);
    return `${minutes}m ago`;
}
const MyEscalations = () => {
    var _a;
    const { getLocalSpecificString } = useLocaleStrings();
    const statusLabels = {
        open: getLocalSpecificString("statusOpen"),
        closed: getLocalSpecificString("statusClosed"),
        notAvailable: getLocalSpecificString("statusNotAvailable"),
    };
    const { isConfigurationSet } = useRootContext();
    const MyEscalationsState = UseMyEscalationsState();
    const { GetMyEscalations, RefreshMyEscalations, SetSelectedEscalationRequestNumber, SetMyCasesView, } = UseMyEscalationsDispatch();
    const [myCasesDetails, setMyCasesDetails] = React.useState([]);
    const [myEscalationItems, setMyEscalationItems] = React.useState([]);
    const [searchCriteria, setSearchCriteria] = React.useState({
        filters: {},
        keyword: "",
    });
    const [selections, setSelections] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [detailsview, setDetailsview] = React.useState(false);
    const [searchResultsAnnouncement, setSearchResultsAnnouncement] = React.useState("");
    const [lastUpdated, setLastUpdated] = React.useState(null);
    const [isRefreshing, setIsRefreshing] = React.useState(false);
    const columns = [
        {
            key: "column0",
            name: "Escalation ID",
            fieldName: "escalationId",
            isMultiline: true,
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            showSortIconWhenUnsorted: true,
            onRender: (item) => {
                return (_jsx(ElxLink, Object.assign({ className: "no-underline", onClick: () => detailsInfoLoad(item.escalationId) }, { children: item.escalationId })));
            },
        },
        {
            key: "column1",
            name: "Customer",
            fieldName: "customerName",
            minWidth: 160,
            maxWidth: 300,
            isResizable: true,
            isMultiline: true,
            showSortIconWhenUnsorted: true,
        },
        {
            key: "column2",
            name: "Type",
            fieldName: "escalationFlowType",
            minWidth: 160,
            maxWidth: 300,
            isResizable: true,
            isMultiline: true,
            showSortIconWhenUnsorted: true,
        },
        {
            key: "column3",
            name: "Product/Program",
            fieldName: "product",
            minWidth: 400,
            maxWidth: 1000,
            isResizable: true,
            isMultiline: true,
            showSortIconWhenUnsorted: true,
        },
        {
            key: "column4",
            name: "Associated tickets or IDs",
            fieldName: "supportRequestNumber",
            minWidth: 220,
            maxWidth: 230,
            isResizable: true,
            isMultiline: true,
            showSortIconWhenUnsorted: true,
        },
        {
            key: "column5",
            name: "Status",
            fieldName: "status",
            minWidth: 200,
            maxWidth: 350,
            isResizable: true,
            isMultiline: false,
            showSortIconWhenUnsorted: true,
            onRender: (item) => {
                return renderStatusCell(item, {
                    labels: statusLabels,
                });
            },
        },
        {
            key: "column6",
            name: "Submitted",
            fieldName: "submittedOn",
            minWidth: 200,
            maxWidth: 400,
            isResizable: true,
            showSortIconWhenUnsorted: true,
            isMultiline: true,
            onRender: (item) => {
                if (item.submittedOn !== undefined && item.submittedOn !== null) {
                    const formattedDateTime = convertISOtoLocal(item.submittedOn);
                    return formattedDateTime;
                }
                else {
                    return "Not Available";
                }
            },
        },
    ];
    const filterOptions = [
        {
            pillMode: FilterOptionPillMode.Static,
            field: "customerName",
            label: "Customer Name",
            values: Array.from(new Set(myEscalationItems.map((item) => item.customerName || "NA"))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "product",
            label: "Product",
            values: Array.from(new Set(myEscalationItems.map((item) => item.product || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "status",
            label: "Status",
            values: Array.from(new Set(myEscalationItems.map((item) => item.status || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "escalationFlowType",
            label: "Type",
            values: Array.from(new Set(myEscalationItems.map((item) => item.escalationFlowType || ""))),
            multiselect: true,
        },
        {
            pillMode: FilterOptionPillMode.Static,
            field: "supportRequestNumber",
            label: "Associated tickets or IDs",
            values: Array.from(new Set(myEscalationItems.map((item) => item.supportRequestNumber || ""))),
            multiselect: true,
        },
    ];
    function onBreadcrumbItemClicked() {
        SetMyCasesView(true);
    }
    React.useEffect(() => {
        if (isConfigurationSet)
            GetMyEscalations();
    }, [isConfigurationSet]);
    // Silent background polling for near real-time status updates
    React.useEffect(() => {
        if (!isConfigurationSet)
            return;
        const POLL_INTERVAL_MS = 10000;
        let interval;
        let isMounted = true;
        let inFlight = false;
        const refreshAndTrack = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!isMounted || inFlight)
                return;
            inFlight = true;
            if (isMounted)
                setIsRefreshing(true);
            try {
                yield RefreshMyEscalations();
                if (isMounted)
                    setLastUpdated(new Date());
            }
            finally {
                inFlight = false;
                if (isMounted)
                    setIsRefreshing(false);
            }
        });
        const startPolling = () => {
            if (interval)
                clearInterval(interval);
            interval = setInterval(() => {
                refreshAndTrack();
            }, POLL_INTERVAL_MS);
        };
        const handleVisibilityChange = () => {
            if (document.hidden) {
                if (interval)
                    clearInterval(interval);
                interval = undefined;
            }
            else {
                refreshAndTrack();
                startPolling();
            }
        };
        if (!document.hidden) {
            startPolling();
        }
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            isMounted = false;
            if (interval)
                clearInterval(interval);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [isConfigurationSet]);
    React.useEffect(() => {
        var _a;
        try {
            setLoading(MyEscalationsState.InProgress);
            if (MyEscalationsState === null || MyEscalationsState === void 0 ? void 0 : MyEscalationsState.Escalations) {
                setLastUpdated(new Date());
                // Get the anchor element by its label attribute
                const anchorElement = document.querySelector('[label="ElxBreadcrumbItem"]');
                // Check if the element exists before adding the click event
                if (anchorElement) {
                    // Add the click event listener
                    anchorElement.addEventListener("click", onBreadcrumbItemClicked);
                }
                // Access the data here
                const myescalation = MyEscalationsState.Escalations;
                const consumerEscalation = myescalation === null || myescalation === void 0 ? void 0 : myescalation.consumerEscalation;
                // eslint-disable-next-line prefer-const
                let itemsFinalConsumer = [];
                if (consumerEscalation !== null &&
                    consumerEscalation !== undefined &&
                    consumerEscalation.length > 0) {
                    itemsFinalConsumer = consumerEscalation.map((conEscalation) => {
                        reportInvalidStageProgression(conEscalation, "MyEscalations");
                        return mapMyEscalationToCaseData(conEscalation, "Consumer");
                    });
                }
                const commercialEscalation = myescalation === null || myescalation === void 0 ? void 0 : myescalation.commercialEscalation;
                let itemsFinalCommercial = [];
                if (commercialEscalation !== null &&
                    commercialEscalation !== undefined &&
                    commercialEscalation.length > 0) {
                    itemsFinalCommercial = commercialEscalation.map((conEscalation) => {
                        reportInvalidStageProgression(conEscalation, "MyEscalations");
                        return mapMyEscalationToCaseData(conEscalation, "Commercial");
                    });
                }
                const finalEscalationSummary = itemsFinalCommercial.concat(itemsFinalConsumer);
                const sortedEscalationsArray = sortBy(finalEscalationSummary, (obj) => obj.submittedOn).reverse();
                setMyEscalationItems(sortedEscalationsArray);
                setMyCasesDetails(sortedEscalationsArray);
                let emptyStateTimeoutId;
                if (!(MyEscalationsState === null || MyEscalationsState === void 0 ? void 0 : MyEscalationsState.InProgress)) {
                    setLoading(false);
                    if (sortedEscalationsArray.length === 0) {
                        setSearchResultsAnnouncement("");
                        emptyStateTimeoutId = setTimeout(() => {
                            setSearchResultsAnnouncement("No escalations to display. Your submitted escalations will be shown here.");
                        }, 100);
                    }
                }
                return () => {
                    if (emptyStateTimeoutId) {
                        clearTimeout(emptyStateTimeoutId);
                    }
                };
            }
            else if ((MyEscalationsState === null || MyEscalationsState === void 0 ? void 0 : MyEscalationsState.Error) &&
                ((_a = MyEscalationsState === null || MyEscalationsState === void 0 ? void 0 : MyEscalationsState.Error) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setLoading(false);
            }
        }
        catch (error) {
            logError("Failed to process escalations state", {
                component: "MyEscalations",
                action: "processEscalations",
                error: error instanceof Error ? error.message : String(error),
            });
        }
    }, [MyEscalationsState.Escalations]);
    React.useEffect(() => {
        var _a;
        if (myEscalationItems !== null &&
            myEscalationItems !== undefined &&
            myEscalationItems.length > 0) {
            setLoading(true);
            const searchedobj = myEscalationItems.filter((elobject) => {
                var _a;
                return ((((_a = searchCriteria.keyword) === null || _a === void 0 ? void 0 : _a.trim().length) == 0 ||
                    Object.values(elobject).some((es) => {
                        var _a;
                        return (es === null || es === void 0 ? void 0 : es.toLowerCase().indexOf((_a = searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.keyword) === null || _a === void 0 ? void 0 : _a.toLowerCase())) != -1;
                    })) &&
                    ((selections === null || selections === void 0 ? void 0 : selections.length) == 0 ||
                        (selections === null || selections === void 0 ? void 0 : selections.every((criteria) => {
                            if (criteria.field == "customerName" &&
                                criteria.values !== undefined)
                                return criteria.values.includes(elobject.customerName || "undefined");
                            else if (criteria.field == "product" &&
                                criteria.values !== undefined)
                                return criteria.values.includes(elobject.product || "undefined");
                            else if (criteria.field == "status" &&
                                criteria.values !== undefined)
                                return criteria.values.includes(elobject.status || "undefined");
                            else if (criteria.field == "supportRequestNumber" &&
                                criteria.values !== undefined)
                                return criteria.values.includes(elobject.supportRequestNumber || "undefined");
                            else if (criteria.field == "escalationFlowType" &&
                                criteria.values !== undefined)
                                return criteria.values.includes(elobject.escalationFlowType || "undefined");
                        }))));
            });
            setMyCasesDetails(searchedobj);
            setLoading(false);
            // Announce search results to screen readers
            setSearchResultsAnnouncement("");
            let searchTimeoutId;
            if (((_a = searchCriteria.keyword) === null || _a === void 0 ? void 0 : _a.trim().length) > 0 || (selections && selections.length > 0)) {
                searchTimeoutId = setTimeout(() => {
                    if (searchedobj.length === 0) {
                        setSearchResultsAnnouncement("No results found for your search.");
                    }
                    else {
                        setSearchResultsAnnouncement(`${searchedobj.length} result${searchedobj.length === 1 ? '' : 's'} found.`);
                    }
                }, 100);
            }
            return () => {
                if (searchTimeoutId) {
                    clearTimeout(searchTimeoutId);
                }
            };
        }
    }, [searchCriteria, selections]);
    const detailsInfoLoad = (escalationRequestNumber) => {
        setDetailsview(true);
        SetMyCasesView(false);
        SetSelectedEscalationRequestNumber(escalationRequestNumber);
    };
    function renderSubHeader() {
        return (_jsx(ElxText, Object.assign({ "data-testid": "subtitle", className: "MyEscalationsHeaderText", "aria-label": " Track your escalations and advocate on behalf of your customers" }, { children: "Track your escalations and advocate on behalf of your customers" })));
    }
    function renderHeader() {
        return (_jsx("h1", Object.assign({ style: { fontSize: "x-large", marginTop: 0 }, className: "MyEscalationsHeader" }, { children: "My Cases" })));
    }
    return (_jsxs("div", Object.assign({ className: useEfdContainerStyles }, { children: [_jsx("div", Object.assign({ role: "status", "aria-live": "polite", "aria-atomic": "true", className: visuallyHiddenStyle.srOnly }, { children: searchResultsAnnouncement })), (MyEscalationsState.MyCasesViewDefault || detailsview === false) && (_jsx(ElxContainer, Object.assign({ "data-testid": "mycasescontainer", headerText: getLocalSpecificString("myEscalationsHeader"), fillBackground: true, subHeaderText: getLocalSpecificString("myEscalationsSubHeader"), headerContent: _jsx("div", { children: _jsx(ElxActionButton, { "data-testid": "createescalation", iconProps: { iconName: "Add" }, text: "Create an escalation", href: "/escalation" }) }), onRenderSubHeader: renderSubHeader, onRenderHeader: renderHeader, className: headerStyle }, { children: _jsxs(Stack, { children: [_jsxs(Stack.Item, Object.assign({ tokens: topStack }, { children: [_jsxs(Stack, Object.assign({ horizontal: true, horizontalAlign: "space-between", verticalAlign: "center" }, { children: [_jsx("h2", Object.assign({ style: { margin: 0 } }, { children: "My escalations" })), !loading && lastUpdated && (_jsx(Text, Object.assign({ variant: "small", "data-testid": "last-updated-indicator", styles: lastUpdatedStyle }, { children: isRefreshing ? "Refreshing..." : `Updated ${formatRelativeTime(lastUpdated)}` })))] })), loading && _jsx(Spinner, { size: SpinnerSize.large })] })), loading === false && (_jsx(Stack.Item, Object.assign({ className: "searchAndFilter", "data-testid": "searchandfilter" }, { children: _jsxs(Stack, Object.assign({ horizontal: true, horizontalAlign: "start", tokens: { childrenGap: 10 } }, { children: [_jsx(Stack.Item, { children: _jsx(ElxSearchBox, { "aria-label": "searchbox", "data-testid": "searchbox", placeholder: getLocalSpecificString("mycasesSearchPlaceHolder"), size: SearchBoxSize.Medium, onChange: (value) => setSearchCriteria(value) }) }), _jsx(Stack.Item, { children: _jsx(ElxFilter, { "aria-label": "filterOptions", options: filterOptions, styles: { root: { width: 400 } }, selections: selections, onChange: setSelections }) })] })) }))), loading === false && (myCasesDetails === null || myCasesDetails === void 0 ? void 0 : myCasesDetails.length) === 0 && (_jsxs("div", Object.assign({ className: "norecordsDisplayContainer" }, { children: [_jsx(Icon, { className: "norecordsImage", imageProps: { src: NoEscalationImage }, "aria-hidden": "true" }), _jsx(Label, Object.assign({ className: "noRecordsFontDisplay" }, { children: ((_a = searchCriteria.keyword) === null || _a === void 0 ? void 0 : _a.trim().length) > 0
                                        ? "No results found for your search."
                                        : "No escalations to display." })), _jsx(Label, { children: "Your submitted escalations will be shown here. Create an escalation to get started" }), _jsx(ElxNavLink, Object.assign({ tabIndex: -1, to: getLocalSpecificString("myescalationsLink") }, { children: _jsx(ElxPrimaryButton, { "data-testid": "createescalation", text: "Create an escalation", href: "/escalation", className: "norecordsImage" }) }))] }))), myCasesDetails && myCasesDetails.length > 0 && (_jsx(Stack.Item, Object.assign({ tokens: midStack }, { children: _jsx(ElxTable, { "data-testid": "mycaseslist", className: "EscalationsList", selectionMode: SelectionMode.none, items: myCasesDetails, columns: columns }) })))] }) }))), !MyEscalationsState.MyCasesViewDefault && detailsview && (_jsx(DetailsPage, { showDetails: detailsview, setShowDetails: setDetailsview }))] })));
};
export default MyEscalations;
